import logo from './logo.svg';
import './App.css';
import Test1 from './components/Test1';
import LoginPage from './pages/LoginPage';
import { Routes, Route } from 'react-router-dom';


function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
    </Routes>
  );
}

export default App;
